import { gql } from '@apollo/client';

/**
 * Query to get all rules with filtering and pagination
 * Matches backend: getRules(filter: RulesFilterInput): RulesResponse!
 */
export const GET_ALL_RULES_QUERY = gql`
  query GetAllRules($filter: RulesFilterInput) {
    getRules(filter: $filter) {
      success
      message
      items {
        ruleId
        name
        ruleStatus
        approvalStatus
        priority
        redirectUrl
        ruleStartFrom
        ruleEndAt
        brandName
        athleteFullName
        boundingBox {
          west
          east
          south
          north
        }
        countries
        categories
        divisions
        gtins
        qrs
        styleColorCodes
        styleCodes
        createdBy
        createdAt
        updatedBy
        updatedAt
        approvedBy
        approvedAt
        pendingChanges {
          operationType
          requestedBy
          requestedAt
          changes
        }
        changeHistory {
          status
          timestamp
          operationType
          requestedBy
          modifiedBy
          changes
        }
        claravineStatus
        claravineUrl
        claravineError
      }
      count
      totalCount
      hasMore
    }
  }
`;

/**
 * Query to get a single rule by ID
 * Matches backend: getRule(ruleId: ID!): GetRuleResponse!
 */
export const GET_RULE_QUERY = gql`
  query GetRule($ruleId: ID!) {
    getRule(ruleId: $ruleId) {
      success
      message
      rule {
        ruleId
      name
      ruleStatus
      approvalStatus
      priority
      redirectUrl
      ruleStartFrom
      ruleEndAt
      athleteFullName
      brandName
      ttl
      boundingBox {
        west
        east
        south
        north
      }
      countries
      categories
      divisions
      gtins
      qrs
      styleColorCodes
      styleCodes
      approvedBy
      approvedAt
      rejectedBy
      rejectedAt
      rejectionReason
      createdBy
      createdAt
      updatedBy
      updatedAt
      pendingChanges {
        operationType
        requestedBy
        requestedAt
        changes
      }
      changeHistory {
        status
        timestamp
        operationType
        requestedBy
        modifiedBy
        changes
      }
      claravineStatus
      claravineUrl
      claravineError
      }
    }
  }
`;

/**
 * Health check query
 * Matches backend: health: String!
 */
export const HEALTH_QUERY = gql`
  query Health {
    health
  }
`;

/**
 * Validate if a rule name is available (not already in use)
 * Matches backend: validateRuleName(name: String!): RuleNameValidationResult!
 */
export const VALIDATE_RULE_NAME_QUERY = gql`
  query ValidateRuleName($name: String!) {
    validateRuleName(name: $name) {
      isValid
      message
    }
  }
`;

/**
 * Check if current user is admin
 * Matches backend: isCurrentUserAdmin: AdminCheckResult!
 */
export const IS_CURRENT_USER_ADMIN_QUERY = gql`
  query IsCurrentUserAdmin {
    isCurrentUserAdmin {
      isAdmin
      userEmail
      groups
    }
  }
`;

/**
 * Test a rule by running the 3-step QR validation flow
 * Matches backend: testRule(ruleId: ID!, location: TestLocationInput): ValidationResult!
 */
export const TEST_RULE_QUERY = gql`
  query TestRule($ruleId: ID!, $location: TestLocationInput, $productCodeOverride: String) {
    testRule(ruleId: $ruleId, location: $location, productCodeOverride: $productCodeOverride) {
      success
      overallStatus
      message
      ruleId
      ruleName
      steps {
        step
        name
        status
        duration
        input
        output
        error
      }
      timestamp
    }
  }
`;

// Legacy queries removed - not supported by backend
// - LIST_RULES_QUERY (use GET_ALL_RULES_QUERY instead)
// - SEARCH_RULES_QUERY (not implemented in backend)
